import { Box } from 'braid-design-system';

import CertsyBrand from 'src/components/common/Certsy/Icons/CertsyBrand';

import * as styles from './CertsyBrandTooltipContent.css';

export const CertsyBrandTooltipContent = () => (
  <Box display="flex" alignItems="center" className={styles.certsyBrand}>
    <CertsyBrand />
  </Box>
);
